<template>
    <modal name="first-login-2" :classes="['v--modal', 'error-modal', 'first-login', hasBugs && 'has-bugs']"
        @before-open="beforeOpen" @before-close="beforeClose" :width="400" :height="'auto'" :scrollable="true"
        :adaptive="true">
        <div class="modal-title">{{ $t("firstLogin.yourAvatar") }}</div>
        <div class="modal-body">
            <div v-if="!avatar || errors.has('avatar')" class="no-avatar"></div>
            <div v-else class="first-login-avatar">
                <div class="modal-subtitle">
                    {{ $t("firstLogin.selectedWillShow") }}
                </div>
                <div class="upload-avatar-wrapper">
                    <vue-cropper :viewMode=1 ref="cropper" :src="avatar" alt="Source Image" :aspectRatio="220 / 310"
                        :guides=false :center=false :zoomOnWheel=false :minCropBoxWidth=220 :minCropBoxHeight=310
                        :background=false class="upload-avatar-cropper">
                    </vue-cropper>
                </div>
            </div>
            <div class="upload-avatar-input">
                <label class="button-blue">
                    <input type="file" accept="image/*" id="avatar" name="avatar" @change="addImage($event, 'avatar')"
                        v-validate="{
                            size: 5000,
                            ext: ['jpeg', 'jpg', 'png'],
                            mindimensions: [220, 310]
                        }" data-vv-as="file" class="input-hidden">
                    {{ $t("firstLogin.selectFile") }}
                </label>
                <div class="v-error">{{ errors.first('avatar') }}</div>
            </div>
            <div class="modal-subtitle">
                {{ $t("firstLogin.maximumFile5") }} <br>
                {{ $t("firstLogin.formatsJpg") }}
            </div>
            <div class="form-bottom buttons-center">
                <button @click="next(false)" v-if="!loader" :disabled="!avatar || errors.has('avatar')" class="button">{{
                    $t("firstLogin.next") }}</button>
                <button v-else class="button button-loader"></button>
                <br>
                <span @click="next(true)" class="link">{{ $t("firstLogin.skipStep") }}</span>
            </div>
        </div>
    </modal>
</template>

<script>
import { mapGetters } from 'vuex';
import { uploadImage } from '@/mixins/uploadImage';
import { localizeValidation } from '@/mixins/localizeValidation';
import { checkScroll } from '@/mixins/checkScroll';
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';

export default {
    name: 'FirstLogin2',
    props: {
        i18n: Object,
    },
    components: {
        VueCropper
    },
    mixins: [
        uploadImage,
        localizeValidation,
        checkScroll
    ],
    data() {
        return {
            hasBugs: false,
            loader: false,
            avatar: '',
            tempUser: {}
        }
    },
    computed: {
        ...mapGetters({
            user: 'user/fetchUser',
            userErrors: 'user/errors',
            isEmpty: 'user/isEmpty'
        }),
        localUser: function () {
            if (Object.keys(this.tempUser).length) {
                return this.tempUser;
            }
            this.tempUser = Object.assign({}, this.user);
            return this.tempUser;
        }
    },
    methods: {
        beforeOpen(event) {
            this.checkScroll();
            this.localizeValidation();
            this.tempUser = event.params.localUser;
            const minDimensionsRule = {
                getMessage(field, [width, height], data) {
                    return (data && data.message) || `Изображение должно быть не менее чем ${width}*${height} пикселей`;
                },
                validate(files, [width, height]) {
                    const validateImage = (file, width, height) => {
                        const URL = window.URL || window.webkitURL;
                        return new Promise(resolve => {
                            const image = new Image();
                            image.onerror = () => resolve({ valid: false });
                            image.onload = () => resolve({
                                valid: image.width >= Number(width) && image.height >= Number(height)
                            });

                            image.src = URL.createObjectURL(file);
                        });
                    };
                    const list = [];
                    for (let i = 0; i < files.length; i++) {
                        if (! /\.(jpg|svg|jpeg|png|bmp|gif)$/i.test(files[i].name)) {
                            return false;
                        }
                        list.push(files[i]);
                    }
                    return Promise.all(list.map(file => validateImage(file, width, height)));
                }
            };

            this.$validator.extend('mindimensions', minDimensionsRule);
        },
        beforeClose(event) {
            if (
                !this.isEmpty('user') &&
                (
                    !this.tempUser.first_name ||
                    !this.tempUser.last_name ||
                    (this.tempUser.gender != 1 && this.tempUser.gender != 2) ||
                    !this.tempUser.birthday
                )
            ) {
                this.hasBugs = true;
                event.stop();
                document.body.classList.add('v--modal-block-scroll')
            } else {
                this.checkRemoveScroll();
                this.errors.clear();
                this.$validator.reset();
                this.avatar = '';
            }
        },
        next(skip = false) {
            this.tempUser.avatar = this.$refs.cropper && !skip ?
                this.$refs.cropper.getCroppedCanvas().toDataURL() :
                undefined;
            this.$modal.hide('first-login-2');
            this.$modal.show('first-login-3', { 'localUser': this.localUser });
        }
    }
}
</script>

<style lang="scss">
@import '~@/assets/styles/components/_cropper';
@import '~@/assets/styles/layout/_upload-avatar';

.error-modal {
    transition: box-shadow 1s;

    &.has-bugs {
        box-shadow: 0 24px 80px -2px rgba(255, 0, 0, .4) !important;
    }
}
</style>
